import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getVentilatorSelector } from '../selectors'
import { VentilatorConstants } from '../store/ventilator.constants'
import { IVentilatorState } from '../store/ventilator.types'

export function* setProcedureComplications() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const ventilatorState: IVentilatorState = yield select(getVentilatorSelector)
  const { inputRows } = procedureState
  const { procedureComplications } = ventilatorState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === VentilatorConstants.SET_PROCEDURE_COMPLICATIONS) {
        //@ts-ignore
        input.props.savedValues = procedureComplications
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setProcedureComplicationsSaga() {
  yield takeLatest([VentilatorConstants.SET_PROCEDURE_COMPLICATIONS], setProcedureComplications)
}
